import { axios } from "../helpers/axios"

/**
 * Fetches all images from the synthetic dataset based on provided tags.
 * @param payload - Object containing tag filters.
 * @returns Promise resolving to the list of images.
 */
export const getAllImages = (payload: any) => {
    return axios.post("synthetic_data/get_images_by_tags/", payload)
}

/**
 * Fetches the list of defects and part defects from the defect library.
 * @param payload - Object containing filter criteria.
 * @returns Promise resolving to the list of defects.
 */
export const getDefectsList = (payload: any) => {
    return axios.post("/synthetic_data/get_defect_library_and_part_defects/", payload)
}

/**
 * Updates augmentation configurations and ROI for images.
 * @param payload - Configuration data for augmentation and ROI.
 * @returns Promise resolving to the update result.
 */
export const updateAugmentationConfigurations = (payload: any) => {
    return axios.post("/synthetic_data/update_augmentation_per_image_configurations_and_roi/", payload);
};

/**
 * Fetches updates related to synthetic data.
 * @param payload - Data for fetching updates.
 * @returns Promise resolving to the updates.
 */
export const getSyntheticDataUpdates = (payload: any) => {
    return axios.post("/synthetic_data/get_synthetic_data_updates/", payload);
};

/**
 * Fetches synthetic data based on provided criteria.
 * @param payload - Data for fetching synthetic data.
 * @returns Promise resolving to the synthetic data.
 */
export const getSyntheticData = (payload: any) => {
    return axios.post("/synthetic_data/get_synthetic_data/", payload);
};

/**
 * Exports frames from the synthetic dataset.
 * @param payload - Data specifying which frames to export.
 * @returns Promise resolving to the export result.
 */
export const exportFrames = (payload: any) => {
    return axios.post("/synthetic_data/export_frames/", payload);
};

/**
 * Downloads frames from the synthetic dataset.
 * @param payload - Data specifying which frames to download.
 * @returns Promise resolving to the download result.
 */
export const downloadFrames = (payload: any) => {
    return axios.post("/synthetic_data/download_synthetic_data/", payload);
};

/**
 * Deletes synthetic data based on provided criteria.
 * @param payload - Data specifying which synthetic data to delete.
 * @returns Promise resolving to the deletion result.
 */
export const deleteSyntheticData = (payload: any) => {
    return axios.post("/synthetic_data/delete_synthetic_data/", payload);
};

/**
 * Fetches details for a specific part by its ID.
 * @param part_id - The part identifier.
 * @returns Promise resolving to the part details.
 */
export const getPartDetails = (part_id: any): Promise<any> => {
    return axios.get(`parts/get_part_by_id/${part_id}`);
};

/**
 * Fetches all parts for a given usecase.
 * @param payload - The usecase identifier.
 * @returns Promise resolving to the list of parts.
 */
export const getAllPartsForUsecase = (payload: any): Promise<any> => {
    return axios.get(`parts/get_all_parts_for_usecase/${payload}`);
};

/**
 * Fetches details for a single workstation by its ID.
 * @param id - The workstation identifier.
 * @returns Promise resolving to the workstation details.
 */
export const getWorkstationDetails = (id: any): Promise<any> => {
    return axios.get(`workstations/workstation/${id}`);
};

/**
 * Fetches details for a specific usecase by its ID.
 * @param usecase_id - The usecase identifier.
 * @returns Promise resolving to the usecase details.
 */
export const getUsecaseDetails = (usecase_id: any): Promise<any> => {
    return axios.get(`usecase/usecase_detail/${usecase_id}`);
};

